class BaoProductCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements.concat(['slides', 'slide', 'dot', 'previous', 'next'])
  }

  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: this.dataset.mobileSlidesAmount,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 750px)': {
            slides: {
              perView: this.dataset.tabletSlidesAmount,
              spacing: 0,
            },
          },
          '(min-width: 990px)': {
            slides: {
              perView: this.dataset.desktopSlidesAmount,
              spacing: 0,
            },
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(
          this.els.dot.elements,
          (carousel, dot, index) => {
            const amountOfSlides = carousel.slides.length
            const slidesPerView = carousel.options.slides.perView
            const shouldHideSlide =
              index >= amountOfSlides - (slidesPerView - 1)

            dot.setAttribute('aria-hidden', shouldHideSlide.toString())
          },
        ),
        window.BAO.Carousel.useArrows({
          previous: this.els.previous.element,
          next: this.els.next.element,
        }),
      ],
    )
  }
}

if (!customElements.get('bao-product-carousel')) {
  customElements.define('bao-product-carousel', BaoProductCarousel)
}
